export default defineNuxtRouteMiddleware(async () => {
	const appointmentPlanner = useAppointmentPlanner();

	const remainingSlots = appointmentPlanner.remainingSlots.value;

	if (Object.values(remainingSlots).reduce((acc, val) => acc + val, 0) > 0) {
		return;
	}

	await appointmentPlanner.fetchRemainingSlots();
});
